__turbopack_context__.v({
  "appCaption": "finnishTransportAgency-module__HvEt7a__appCaption",
  "appImage": "finnishTransportAgency-module__HvEt7a__appImage",
  "appItem": "finnishTransportAgency-module__HvEt7a__appItem",
  "applicationsGrid": "finnishTransportAgency-module__HvEt7a__applicationsGrid",
  "applicationsHeader": "finnishTransportAgency-module__HvEt7a__applicationsHeader",
  "applicationsSection": "finnishTransportAgency-module__HvEt7a__applicationsSection",
  "colorContent": "finnishTransportAgency-module__HvEt7a__colorContent",
  "colorIntro": "finnishTransportAgency-module__HvEt7a__colorIntro",
  "colorSection": "finnishTransportAgency-module__HvEt7a__colorSection",
  "hero": "finnishTransportAgency-module__HvEt7a__hero",
  "maritimeGrid": "finnishTransportAgency-module__HvEt7a__maritimeGrid",
  "metaBlock": "finnishTransportAgency-module__HvEt7a__metaBlock",
  "metaGrid": "finnishTransportAgency-module__HvEt7a__metaGrid",
  "metaLabel": "finnishTransportAgency-module__HvEt7a__metaLabel",
  "metaLeft": "finnishTransportAgency-module__HvEt7a__metaLeft",
  "metaOverview": "finnishTransportAgency-module__HvEt7a__metaOverview",
  "metaRight": "finnishTransportAgency-module__HvEt7a__metaRight",
  "metaSection": "finnishTransportAgency-module__HvEt7a__metaSection",
  "metaText": "finnishTransportAgency-module__HvEt7a__metaText",
  "metaTools": "finnishTransportAgency-module__HvEt7a__metaTools",
  "outcomesSection": "finnishTransportAgency-module__HvEt7a__outcomesSection",
  "page": "finnishTransportAgency-module__HvEt7a__page",
  "processSection": "finnishTransportAgency-module__HvEt7a__processSection",
  "resultDetail": "finnishTransportAgency-module__HvEt7a__resultDetail",
  "resultItem": "finnishTransportAgency-module__HvEt7a__resultItem",
  "resultLabel": "finnishTransportAgency-module__HvEt7a__resultLabel",
  "resultValue": "finnishTransportAgency-module__HvEt7a__resultValue",
  "resultsContent": "finnishTransportAgency-module__HvEt7a__resultsContent",
  "resultsGrid": "finnishTransportAgency-module__HvEt7a__resultsGrid",
  "resultsSection": "finnishTransportAgency-module__HvEt7a__resultsSection",
  "storySection": "finnishTransportAgency-module__HvEt7a__storySection",
  "teamAvatar": "finnishTransportAgency-module__HvEt7a__teamAvatar",
  "teamAvatarPlaceholder": "finnishTransportAgency-module__HvEt7a__teamAvatarPlaceholder",
  "teamContent": "finnishTransportAgency-module__HvEt7a__teamContent",
  "teamGrid": "finnishTransportAgency-module__HvEt7a__teamGrid",
  "teamMember": "finnishTransportAgency-module__HvEt7a__teamMember",
  "teamName": "finnishTransportAgency-module__HvEt7a__teamName",
  "teamRole": "finnishTransportAgency-module__HvEt7a__teamRole",
  "teamSection": "finnishTransportAgency-module__HvEt7a__teamSection",
  "typographyContent": "finnishTransportAgency-module__HvEt7a__typographyContent",
  "typographyIntro": "finnishTransportAgency-module__HvEt7a__typographyIntro",
  "typographyNote": "finnishTransportAgency-module__HvEt7a__typographyNote",
  "typographySection": "finnishTransportAgency-module__HvEt7a__typographySection",
  "typographyWaterfall": "finnishTransportAgency-module__HvEt7a__typographyWaterfall",
  "waterfallBody": "finnishTransportAgency-module__HvEt7a__waterfallBody",
  "waterfallCaption": "finnishTransportAgency-module__HvEt7a__waterfallCaption",
  "waterfallHeader": "finnishTransportAgency-module__HvEt7a__waterfallHeader",
  "waterfallItem": "finnishTransportAgency-module__HvEt7a__waterfallItem",
  "waterfallLabel": "finnishTransportAgency-module__HvEt7a__waterfallLabel",
  "waterfallSubhead": "finnishTransportAgency-module__HvEt7a__waterfallSubhead",
});
